import { appVersionAtLeast } from 'shared/javascripts/util/detection'
import session from 'frontend/shared/javascripts/util/session'
import { trackEvent } from 'frontend/shared/javascripts/util/analytics'

export function eligibleForAppRatingOverlay(): boolean {
  return appVersionAtLeast(1) && !session.appRatingOverlaySeen && session.seenVideos >= 3
}

export function showAppRatingOverlay(modalPath: string): void {
  session.appRatingOverlaySeen = true
  trackEvent('appRating.overlaySeen')
  void up.layer.open({
    url: modalPath,
    layer: 'new',
    history: false,
    class: ['reminder-modal', 'reminder-modal--rating'],
    abort: 'all',
  })
}
